import { ErrorBoundary } from 'react-error-boundary'
import { useLocation, Outlet } from 'react-router-dom'
import ErrorPage from './ErrorPage'

const ErrorBoundaryWrapper = () => {
  const location = useLocation()

  return (
    <ErrorBoundary FallbackComponent={ErrorPage} resetKeys={[location.pathname]}>
      <Outlet />
    </ErrorBoundary>
  )
}

export default ErrorBoundaryWrapper
